import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { getDatabaseCart } from '../../utilities/databaseManager';
import ScrollToTop from "react-scroll-to-top";
import { collectionContext } from '../../App';
import SimilarProduct from '../SimilarProduct/SimilarProduct';
import SingleProduct from './SingleProduct';
import RecentlyViewed from '../RecentlyViewed/RecentlyViewed';
import { useGetSimmilarProductQuery, useRecentViewedProductMutation, useSingleProductQuery } from '../../features/api/apiSlice';
import { useSelector, useDispatch } from 'react-redux';
import './spinner.css'
import { openPopup } from '../../features/cart/cartSlice';

const Singleproductpage = () => {
    const { id, type } = useParams();
    const { value1, value3 } = useContext(collectionContext);
    const [cartData, setCartData] = value1;
    const [recentKey, setRecentKey] = value3;
    const [snackPack, setSnackPack] = useState([]);
    const [messageInfo, setMessageInfo] = useState(undefined);
    const [currentProduct, setCurrentProduct] = useState([]);
    const [simillarCard, setSimillarCard] = useState([]);
    const [recentCard, setRecentCard] = useState([]);
    const { click, open } = useSelector(state => state.cart);
    const dispatch = useDispatch()

    const { data: singleProduct, isLoading, isError } = useSingleProductQuery({ type, id });
    const { data: similarProduct } = useGetSimmilarProductQuery(type);
    const [recentViewedProduct] = useRecentViewedProductMutation()

    // const addToCart = (id, counter) => {
    //     const message = 'Item added to Cart'
    //     setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
    //     addToDatabaseCart(id, counter);
    //     setClick(true);
    //     setRefresh(true);
    //     setOpen(true);
    // }



    useEffect(() => {
        setCurrentProduct(singleProduct ? singleProduct[0] : []);
        setRecentKey([...recentKey, id])
        // eslint-disable-next-line
    }, [id, singleProduct])
    useEffect(() => {
        const savedCart = getDatabaseCart();
        const productKeys = Object.keys(savedCart);
        const previousCart = productKeys.map(existingKey => {
            const productQty = currentProduct;
            productQty.orderQuantity = savedCart[existingKey];
            return productQty;
        })
        setCartData(previousCart);
        // eslint-disable-next-line
    }, [])



    useEffect(() => {
        if (snackPack.length && !messageInfo) {
            setMessageInfo({ ...snackPack[0] });
            setSnackPack((prev) => prev.slice(1));
            dispatch(openPopup(true))
            // setOpen(true);
        } else if (snackPack.length && messageInfo && open) {
            dispatch(openPopup(false))
        }
    }, [snackPack, messageInfo, open, dispatch]);




    useEffect(() => {
        setSimillarCard(similarProduct);
    }, [similarProduct])

    useEffect(() => {

        recentViewedProduct(recentKey).then(data => {
            setRecentCard(data.data)
        })

    }, [recentKey, recentViewedProduct]);

    // ৳

    // Describe what to do render
    let content = null;
    if (isLoading) content = <div className="loading">Loading&#8230;</div>

    if (!isLoading && !isError && currentProduct?._id) {
        content = <div>
            <ScrollToTop smooth />
            <Navbar />
            <SingleProduct open={open} currentProduct={currentProduct} cartData={cartData} id={id} click={click} setSnackPack={setSnackPack} />
            <SimilarProduct simillarCard={simillarCard} title={'Similar Product'} />
            <RecentlyViewed recentCard={recentCard} title={'Recently Viewed'} />
            <Footer />
        </div>
    }

    return (
        content
    );
}

export default Singleproductpage;
